import { useState, useContext } from "react";
import { removerDataInnecesaria } from "../solicitudes-en-curso/useSolicitudesCurso";
import { useSolicitudesCurso } from "../solicitudes-en-curso/useSolicitudesCurso";
import { DataContextContractual } from "../../contextData/contextData";
import { mensajeSimple } from "../../components/ui/sweetAlerts";
import { validaGetStatus } from "../../utils/funciones";
import { cerrarSession } from "../../utils/funciones";
import { useExcel } from "../../hooks/generarExcel";
import { postWithResponse } from "../../api/apis";
import { ModalEnviarSAP } from "./modalEnviarSAP";
import { getUno } from "../../api/apis";
import { useIndex } from "../useIndex";

export const useEnviarSAP = () => {
  const { dataListado, setDataListado } = useContext(DataContextContractual);
  const [enviandoActual, setEnviandoActual] = useState(undefined);
  const [arrSolicitudes, setArrSolicitudes] = useState([]);
  const [arrEnviadasSAP, setArrEnviadasSAP] = useState([]);
  const [visibleModal, setVisibleModal] = useState(false);
  const [aprueba, setAprueba] = useState("");
  const [lista, setLista] = useState([]);
  const { generarExcel } = useExcel();
  const { formatFecha } = useIndex();
  const { traerListado } = useSolicitudesCurso();
  const [cant, setCant] = useState(0);
  const [limpioSelected, setLimpioSelected] = useState(false);


  const hideModalSAP = () => {
    setArrEnviadasSAP([]);
    setVisibleModal(!visibleModal);
  }

  function setearMensaje(resp) {
    setArrEnviadasSAP((arrEnviadasSAP) => [...arrEnviadasSAP, resp]);
  }

  const envioMasivoSAP = async (arr, aprueba) => {
    setAprueba(aprueba);
    setVisibleModal(true);

    for (const elm of arr) {
      setEnviandoActual(() => elm);
      const resp = await postWithResponse('getlistado', {}, { ...removerDataInnecesaria(elm), observacion: "Envio masivo", aprueba: aprueba });

      setearMensaje({ resp, persona: elm.persona });
      setEnviandoActual(() => null);
    }
    setArrSolicitudes([]);
    setLimpioSelected(true);
    setTimeout(() => {
      setLimpioSelected(false);
    }, 200);
    traerListado();
  }

  let objModalSAP = {
    titulo: aprueba ? "Enviando a SAP" : "Rechazando solicitudes",
    component: <ModalEnviarSAP cont={cant} arr={arrEnviadasSAP} actual={enviandoActual} hideModal={hideModalSAP} />
  }

  const seleccionarContrato = (obj) => {
    setLimpioSelected(false);
    setArrSolicitudes(obj.selectedRows);
    setCant(obj.selectedRows.length);
  }

  const filtrarSap = (txt) => {
    const regExpr = new RegExp(`${txt}`, 'i');

    const listaFiltrada = dataListado.arrData.filter(el => {
      return (
        regExpr.test(el.persona.nombre) ||
        regExpr.test(el.persona.identificacion) ||
        regExpr.test(formatFecha(el.fecha_inicio_cambio.replace(/-/g, ''))) ||
        regExpr.test(el.tipo_solicitud_cambio_contraactual.nombre)
      )
    });
    setLista(listaFiltrada);
  }

  const traerListadoSAP = async () => {
    const resp = await getUno('getallporenviarsap', null, null);

    if (!validaGetStatus(resp)) {
      cerrarSession();
    }
  }

  const descargarExcelCambioContrato = async () => {
    try {
      const resp = await getUno('getexcelcambiocontrato', null, null);

      const lista = resp.data.data;

      const titulosTabla = Object.keys(lista[0]);
      const arr = [
        { name: 'ID_TRANSACCION', width: 7 },
        { name: 'PERNR', width: 5 },
        { name: 'RUT', width: 5 },
        { name: 'BEGDA', width: 6 },
        { name: 'ENDDA', width: 5 },
        { name: 'MASSN', width: 5 },
        { name: 'MASSG', width: 5 },
        { name: 'CTTYP', width: 5 },
        { name: 'CTEDT', width: 5 },
      ]
      await generarExcel({
        arrData: lista,
        arrHeaders: titulosTabla,
        sheetHeadersArr: arr.map(el => el.name),
        sheetColumnWidth: arr.map(el => el.width),
        fileName: 'tabla'
      });
      mensajeSimple('success', 'Listo!', 1000);
    } catch (error) {
      mensajeSimple('error', '¡No fue posible generar el Excel!', 2500);
    }
  }

  const descargarExcel = async () => {
    try {
      const resp = await getUno('getexcelbase', null, null);
      const lista = resp.data.data.map((el) => {
        return ({ ...el, SCHKZ: el.SCHKZ?.split('|')[1] || '' });
      });

      const titulosTabla = Object.keys(lista[0]);
      const arr = [
        { name: 'ID_TRANSACCION', width: 7},
        { name: 'PERNR', width: 5 },
        { name: 'RUT', width: 5 },
        { name: 'BEGDA', width: 6 },
        { name: 'ENNDA', width: 5 },
        { name: 'MASSN', width: 5 },
        { name: 'MASSG', width: 5 },
        { name: 'BUKRS', width: 5 },
        { name: 'WERKS', width: 5 },
        { name: 'BTRTL', width: 5 },
        { name: 'PERSG', width: 5 },
        { name: 'PERSK', width: 5 },
        { name: 'PLANS', width: 5 },
        { name: 'STELL', width: 5 },
        { name: 'ORGEH', width: 5 },
        { name: 'ABKRS', width: 5 },
        { name: 'ANSVH', width: 5 },
        { name: 'SCHKZ', width: 10 },
        { name: 'Z0001', width: 5 },
        { name: 'Z0002', width: 5 },
        { name: 'Z0003', width: 5 },
        { name: 'Z0004', width: 5 },
      ]
      await generarExcel({
        arrData: lista,
        arrHeaders: titulosTabla,
        sheetHeadersArr: arr.map(el => el.name),
        sheetColumnWidth: arr.map(el => el.width),
        fileName: 'tabla'
      });
      mensajeSimple('success', 'Listo!', 1000);
    } catch (error) {
      mensajeSimple('error', '¡No fue posible generar el Excel!', 2500);
    }
  }

  return {
    traerListadoSAP, arrSolicitudes, seleccionarContrato, filtrarSap, lista, setLista, descargarExcel, descargarExcelCambioContrato, envioMasivoSAP, visibleModal, objModalSAP, hideModalSAP,
    limpioSelected
  }
}